import { ActionContext } from 'vuex';
import { getUserInfo } from '@/api/user';
import { UserDataResponse, UserState } from '@/interfaces/user';

type Context = ActionContext<UserState, never>;

export async function fetchUserInfo(context: Context): Promise<UserDataResponse> {
  const { data } = await getUserInfo();

  context.commit('setUserState', data);

  return data;
}

export function setActiveLoan(context: Context, loanNumber: string) {
  context.commit('setActiveLoan', loanNumber);
}

export function setIsFirstLogin(context: Context, isFirstLogin: boolean) {
  context.commit('setIsFirstLogin', isFirstLogin);
}
